import React from 'react';
import { getPlatformFormFactorSelector } from '../../../platform/platformSelector';
import { useSelector } from 'react-redux';
import { DeviceFormFactor } from '../../../../common/platform/platformTypes';
import TabletEmojiPopupContent from './TabletEmojiPopupContent';
import DesktopEmojiPopupContent from './DesktopEmojiPopupContent';
import { EmojiPopupContentProps } from './emojiPopupConstants';

const EmojiPopupContent = (props: EmojiPopupContentProps) => {
    const { selectedEmojiIds, onSelectEmoji, closePopup } = props;

    const deviceFormFactor = useSelector(getPlatformFormFactorSelector);

    const Component = deviceFormFactor === DeviceFormFactor.tablet ? TabletEmojiPopupContent : DesktopEmojiPopupContent;

    return <Component selectedEmojiIds={selectedEmojiIds} onSelectEmoji={onSelectEmoji} closePopup={closePopup} />;
};

export default EmojiPopupContent;
